import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-option-box3options',
  templateUrl: './option-box3options.component.html',
  styleUrls: ['./option-box3options.component.css']
})
export class OptionBox3optionsComponent implements OnInit {

  public txt: string;
  public option1: string;
  public option2: string;
  public option3: string;

  constructor(public DialogRef: MatDialogRef<OptionBox3optionsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.txt) {
      this.txt = data.txt;
    }

    if (data.option1) {
      this.option1 = data.option1;
    }

    if (data.option2) {
      this.option2 = data.option2;
    }

    if (data.option3) {
      this.option3 = data.option3;
    }


  }



  ngOnInit(): void {

  }

  public Option1() {
    this.DialogRef.close(1);
  }

  public Option2() {
    this.DialogRef.close(2);
  }

  public Option3() {
    this.DialogRef.close(3);
  }

}

